import Vue from 'vue'
import Router from "vue-router"
Vue.use(Router)
const routes = [], funcJs = require.context('./modules', false, /\.js$/)
funcJs.keys().forEach(fn => {
  const obj = funcJs(fn);
  (obj.default || obj).forEach(v => Object.prototype.toString.call(v) === '[object Object]' ? routes.push(v) : '')
})

// console.log('routes',routes)
const router = new Router({ routes })

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router